import _ from "lodash";
import { calculateExpressBonus } from "../../../helpers/sport/betslip";

import { BonusRuleTypeEnum, BonusRuleBasisEnum } from '../../../constants/enums/bonusRule';

const bonusTypeToBasis = {
    [BonusRuleTypeEnum.TotalWinning]: BonusRuleBasisEnum.Return,
    [BonusRuleTypeEnum.NetWinning]: BonusRuleBasisEnum.Profit,
};

export const generatePredefinedMultipleBonusRule = multiple => ({
    AmountPercent: multiple.BonusPercent,
    Basis: bonusTypeToBasis[multiple.BonusType],
    BetType: multiple.BetType,
    MaximumSelections: multiple.Selections.length,
    MinimumSelections: multiple.Selections.length,
    MinBetOdds: 1,
    MinOdds: 1,
    MinBetStakes: {},
});

export const getPredefinedMultipleExpressBonus = (multiple, selections, stake, currency) => {
    const virtualBonusRule = generatePredefinedMultipleBonusRule(multiple);
    const bets = selections.map(item => ({ price: item.Price }));

    const bonus = calculateExpressBonus(bets, +stake, [virtualBonusRule], true, currency);
    return bonus;
}

export const changeTicketResultModel = (ticket) => {
    const result = { ...ticket };

    result.SelectionList = result.SelectionList.map(item => _.mapKeys(item, camelCaseToUnderscored));
    return _.mapKeys(result, camelCaseToUnderscored);
}

const camelCaseToUnderscored = (value, key) => _.kebabCase(key).replace(/-/g, '_');

//* Fancy code ))
// export const changeTicketResultModelNested = (result) => {
//     const update = () => obj => {
//         for (const key in obj) {
//             if (typeof obj[key] === 'object' && obj[key] !== null) {                
//                 update()(obj[key])
//             } else {
//                 const snakeCase =_.kebabCase(key).replaceAll('-', '_')

//                 obj[snakeCase] = obj[key]
//                 delete obj[key]
//             }
//         }
//     };

//     result.forEach(update());

//     return result
// };